import { useState } from "react";
import { Link2, Check } from "lucide-react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { shareLink } from "../lib/api";

// The public share link with a copy button (falls back to a prompt when the clipboard API is blocked).
export const ShareLinkRow = ({ id }) => {
  const [copied, setCopied] = useState(false);
  const url = shareLink(id);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Share link copied!");
      setTimeout(() => setCopied(false), 1800);
    } catch (e) {
      window.prompt("Copy this link", url);
    }
  };

  return (
    <div data-testid="share-row" className="flex items-center gap-2 rounded-full border border-border bg-card/60 pl-4 pr-1.5 py-1.5">
      <Link2 className="h-4 w-4 text-accent shrink-0" />
      <span data-testid="share-link-text" className="flex-1 truncate text-xs font-mono2 text-muted-foreground">{url}</span>
      <Button data-testid="copy-share-link-btn" size="sm" variant="outline" onClick={copy} className="rounded-full h-9 gap-1.5">
        {copied ? <Check className="h-4 w-4" /> : <Link2 className="h-4 w-4" />}
        {copied ? "Copied" : "Copy link"}
      </Button>
    </div>
  );
};
